import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Admin.css';

function AdminLayout({ children }) {
    const { currentUser, userData } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="admin-sidebar-header">
                    <h2>Admin Panel</h2>
                    <span className="admin-role">{userData?.role || 'admin'}</span>
                </div>

                <nav className="admin-nav">
                    <NavLink to="/admin" end className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="nav-icon">📊</span>
                        Dashboard
                    </NavLink>
                    <NavLink to="/admin/users" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="nav-icon">👥</span>
                        Users
                    </NavLink>
                    <NavLink to="/admin/content" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="nav-icon">📚</span>
                        Content
                    </NavLink>
                    <NavLink to="/admin/topics" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="nav-icon">🏷️</span>
                        Topics
                    </NavLink>
                    <NavLink to="/admin/analytics" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="nav-icon">📈</span>
                        Analytics
                    </NavLink>
                    <NavLink to="/admin/logs" className={({ isActive }) => isActive ? 'active' : ''}>
                        <span className="nav-icon">📋</span>
                        Activity Logs
                    </NavLink>
                </nav>

                <div className="admin-sidebar-footer">
                    <div className="admin-user-info">
                        <span className="admin-user-email">{currentUser?.email}</span>
                    </div>
                    <button className="back-to-app-btn" onClick={() => navigate('/home')}>
                        ← Back to App
                    </button>
                </div>
            </aside>

            <main className="admin-main">
                {children}
            </main>
        </div>
    );
}

export default AdminLayout;
